'use client';

import { useMemo } from 'react';

import { Record } from '@personly/libs-widgets';
import { useMediaQuery } from '@personly/libs-hooks';

import TableHeader from '../table-header';

const key = (data, i) =>
  data.reduce((acc, cur) => [...acc, cur.axis], [i]).join(':');

interface Props {
  data: any;
  dimensions: any;
  orientation?: any;
}

const Table = ({ data, dimensions, orientation: orient }: Props) => {
  const isLg = useMediaQuery('(min-width: 992px)');

  const orientation = useMemo(() => {
    if (orient) return orient;
    if (isLg) return 'row';
    return 'column';
  }, [isLg, orient]);

  return (
    <div className="text-xs">
      {orientation === 'row' && dimensions.length > 0 && data.length > 0 && (
        <Record data={dimensions} first last legend orientation={orientation}>
          {(displayHeader, displayValue, datum, legend) => (
            <>
              {displayHeader && (
                <TableHeader
                  orientation={orientation}
                  icon={datum.icon}
                  legend={legend}
                >
                  {datum.header}
                </TableHeader>
              )}
              {displayValue && <div>{datum.value}</div>}
            </>
          )}
        </Record>
      )}
      {data.map((d, i) => (
        <Record
          key={key(d.data, i)}
          data={d.data}
          first={i === 0}
          last={i === data.length - 1}
          legend={false}
          orientation={orientation}
        >
          {(displayHeader, displayValue, datum, legend) => (
            <>
              {displayHeader && (
                <TableHeader
                  orientation={orientation}
                  icon={datum.icon}
                  legend={legend}
                >
                  {datum.header}
                </TableHeader>
              )}
              {displayValue && <div>{datum.value}</div>}
            </>
          )}
        </Record>
      ))}
    </div>
  );
};

export default Table;
